export interface IError {
  status: number;
  message: string;
}
export class Error implements IError {
  status: number;
  message: string;
  constructor(data: IError) {
    Object.assign(this, data);
  }
}